import { FiChevronRight } from 'react-icons/fi';
import { SiIfixit } from 'react-icons/si';

import {
  BsExclamationCircleFill,
  BsFillCheckCircleFill,
  BsFillQuestionCircleFill,
} from 'react-icons/bs';
import { StyledButton } from '../StyledButton';
import { Container, Content } from './styles';
import { ReactNode } from 'react';
import {  IoIosCloseCircleOutline } from 'react-icons/io';

interface IProps {
  type?: 'success' | 'error' | 'warning' | 'info' | 'question';
  title?: string;
  titleButtonOne?: string;
  titleButtonTwo?: string;
  differentColor?: boolean;
  classNameButtons?: string;
  paddingButton?: any;
  iconClose?: boolean;
  text: string | ReactNode;
  setModal: (value: boolean) => void;
  twoButtons?: boolean;
  callActions?: Array<() => void>;
  newAction?: () => void;
}

const StatusModalConfirmClick = ({
  title,
  text,
  type,
  setModal,
  titleButtonOne = 'Confirmar',
  titleButtonTwo = 'Cancelar',
  differentColor = true,
  classNameButtons = 'buttons',
  paddingButton = 16,
  iconClose = false,
  twoButtons,
  callActions,
  newAction
}: IProps) => (
  <Container>
    <Content>
      <div className="icon">
        {type === 'success' && <BsFillCheckCircleFill size={40} />}
        {type === 'error' && <SiIfixit size={40} />}
        {type === 'warning' && <SiIfixit size={40} />}
        {type === 'info' && <BsExclamationCircleFill size={40} />}
        {type === 'question' && <BsFillQuestionCircleFill size={40} />}
      </div>

      <div className="title">{title && <p>{title}</p>}</div>

      <div className="text">
        <p>{text}</p>
      </div>
      <div className={classNameButtons}>
        <StyledButton
          paddingButton={paddingButton}
          icon={!iconClose ? <FiChevronRight /> : <IoIosCloseCircleOutline />}
          iconPosition="right"
          text={titleButtonOne}
          iconWhiteBackground
          iconBorderRadius
          backgroundColor={differentColor ? "blue" : undefined}
          onClick={() => {
            callActions && callActions.map((action) => action());
            setModal(false);
          }}
        />
        {twoButtons && (
          <StyledButton
            paddingButton={paddingButton}
            icon={<FiChevronRight />}
            iconPosition="right"
            text={titleButtonTwo}
            iconWhiteBackground
            iconBorderRadius
            onClick={!newAction ? () => setModal(false) : newAction}
          />
        )}
      </div>
    </Content>
  </Container>
);

export { StatusModalConfirmClick };
